<template>
  <o-section
    :title="label || schema.verbose_name"
    not-closable
    :level="level + 1"
    body-classes="p-0"
  >
    <o-item-editable-table
      v-model="items"
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      @change="changed"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'task')">{{ schema.fields.task.label }}</th>
        <th v-if="canSee(schema, 'when')">{{ schema.fields.when.label }}</th>
        <th v-if="canSee(schema, 'booking_number')">
          {{ schema.fields.booking_number.label }}
        </th>
        <th v-if="canSee(schema, 'supplier')">
          {{ schema.fields.supplier.label }}
        </th>
        <th v-if="canSee(schema, 'costs')">{{ schema.fields.costs.label }}</th>
        <th v-if="canSee(schema, 'invoice_number')">
          {{ schema.fields.invoice_number.label }}
        </th>
        <th v-if="canSee(schema, 'invoice_date')">
          {{ schema.fields.invoice_date.label }}
        </th>
        <th v-if="canSee(schema, 'invoice_paid')">
          {{ schema.fields.invoice_paid.label }}
        </th>
        <th v-if="canSee(schema, 'active_start_date')">
          {{ schema.fields.active_start_date.label }}
        </th>
        <th v-if="canSee(schema, 'active_end_date')">
          {{ schema.fields.active_end_date.label }}
        </th>
      </template>
      <template slot="o-body" slot-scope="{ item, index }">
        <td v-if="canSee(schema, 'task')">
          <o-widget-wrapper
            :schema="schema"
            name="task"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-select
              v-model="items[index].task"
              :items="optionCodeTaskTypeItems"
              text-field="description"
              value-field="id"
              sort-field="description"
              :form-state="formState"
              :loading="optionCodeTaskTypeWorking"
              name="task"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.task"
              allow-add
              store-name="CodeTaskType"
              add-title="Create New"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <code-task-type-form
                  :item="item"
                  :form-state="formState"
                  :server-errors="serverErrors"
                  in-modal
                ></code-task-type-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'when')">
          <o-widget-wrapper
            :schema="schema"
            name="when"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-date-time
              v-model="items[index].when"
              name="when"
              v-bind="schema.fields.when"
              :form-state="formState"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              hide-time
            ></o-date-time>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'booking_number')">
          <o-widget-wrapper
            :schema="schema"
            name="booking_number"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-text-field
              v-model="items[index].booking_number"
              :form-state="formState"
              name="booking_number"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.booking_number"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'supplier')">
          <o-widget-wrapper
            :schema="schema"
            name="supplier"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-select
              v-model="items[index].supplier"
              :items="optionSupplierItems"
              text-field="display_name"
              value-field="id"
              sort-field="display_name"
              :form-state="formState"
              :loading="optionSupplierWorking"
              name="supplier"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.supplier"
              allow-add
              store-name="Supplier"
              add-title="Create New"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <supplier-form
                  :item="item"
                  :form-state="formState"
                  :server-errors="serverErrors"
                  in-modal
                ></supplier-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'costs')">
          <o-widget-wrapper
            :schema="schema"
            name="costs"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <task-cost-form-table
              v-model="items[index].costs"
              :validators="validators.$each[index].costs"
              :form-state="formState"
              :label="schema.fields.costs.label"
              :level="level + 1"
              :server-errors="_se.costs"
            >
            </task-cost-form-table>
            <!-- UNCOMMENT TO USE Cards
<task-cost-form-cards v-model="items[index].costs"
    :validators="validators.$each[index].costs"
    :form-state="formState"
    :label="schema.fields.costs.label"
    :level="level+1"
    :server-errors="_se.costs">
</task-cost-form-cards>
-->
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'invoice_number')">
          <o-widget-wrapper
            :schema="schema"
            name="invoice_number"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-text-field
              v-model="items[index].invoice_number"
              :form-state="formState"
              name="invoice_number"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.invoice_number"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'invoice_date')">
          <o-widget-wrapper
            :schema="schema"
            name="invoice_date"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-date-time
              v-model="items[index].invoice_date"
              name="invoice_date"
              v-bind="schema.fields.invoice_date"
              :form-state="formState"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              hide-time
            ></o-date-time>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'invoice_paid')">
          <o-widget-wrapper
            :schema="schema"
            name="invoice_paid"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-checkbox
              v-model="items[index].invoice_paid"
              :form-state="formState"
              name="invoice_paid"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.invoice_paid"
            ></o-checkbox>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'active_start_date')">
          <o-widget-wrapper
            :schema="schema"
            name="active_start_date"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-date-time
              v-model="items[index].active_start_date"
              name="active_start_date"
              v-bind="schema.fields.active_start_date"
              :form-state="formState"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
            ></o-date-time>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'active_end_date')">
          <o-widget-wrapper
            :schema="schema"
            name="active_end_date"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-date-time
              v-model="items[index].active_end_date"
              name="active_end_date"
              v-bind="schema.fields.active_end_date"
              :form-state="formState"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
            ></o-date-time>
          </o-widget-wrapper>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";
import OItemEditableTable from "../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../vue-ocom/components/layout/OSection";

import { default as TaskCostFormTable } from "../../task_cost/components/ItemFormTable";

export default {
  name: "JobTaskFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("JobTask"),
    CreateCodeTableFetchMixin(["CodeTaskType", "Supplier"]),
  ],
  components: { OItemEditableTable, OSection, TaskCostFormTable },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.JobTask,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.JobTask),
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  },
};
</script>
